import { RouteConfig } from 'vue-router';

import { mailTemplateAddRoute } from './mailTemplate/add.route';
import { mailTemplateEditRoute } from './mailTemplate/edit.route';
import { mailTemplatesRoute } from './mailTemplate/mailTemplates.route';

export const mailTemplateContainerRoute: RouteConfig = {
  path: '/mailtemplates',
  component: () => import(/* webpackChunkName: "RouterView" */ '@/components/appLayout/Router.vue'),
  children: [mailTemplatesRoute, mailTemplateAddRoute, mailTemplateEditRoute],
  meta: {
    breadcrumb: {
      title: 'Szablony wiadomości e-mail',
      name: 'mailTemplates'
    },
    config: {
      title: 'Szablony wiadomości e-mail',
      name: 'mailTemplates',
      icon: 'fa-envelope',
      permissions: ['MAIL_TEMPLATE.UPDATE']
    }
  }
};
